import React from 'react';
import Button from 'common/components/tags/button/Button';
import clsx from 'clsx';
import Typography from 'common/components/tags/typography/Typography';
import Image from 'next/image';
export interface props extends Category {
  className?: string;
}

const TopicItem = ({
  title,
  shortDescription,
  banner,
  id,
  className,
}: props) => {
  return (
    <div
      className={clsx(
        className,
        `border-card rounded-4 xl:rounded-7 bg-white p-5 md:p-7 xl:py-[4.4rem] xl:px-[6.8rem]`,
        'col-span-2 md:col-span-1'
      )}
    >
      <div className='flex items-center'>
        <Image
          src={banner?.downloadUrl}
          alt={title}
          width={37}
          height={37}
          className='object-contain pr-1 xl:pr-2'
        />
        {/* <i className="apollon-key-square pr-1 xl:pr-2 text-[2.5rem] text-black" /> */}
        <div className='webkit-line-clamp-1'>
          <h3 className='text-[2rem] font-[600] xl:text-[3.2rem]'>{title}</h3>
        </div>
      </div>
      <div className='mt-2 md:mt-0'>
        <div className='webkit-line-clamp-2'>
          <Typography variant='p3'>{shortDescription}</Typography>
        </div>
      </div>

      <Button
        label='More Info'
        variant='text-fill'
        type='link'
        path={'/help/categories/' + id}
        iconClassName='arrow-right'
        icon_align='right'
        className='pl-0 font-bold'
      />
    </div>
  );
};

export default TopicItem;
